module.exports = __webpack_public_path__ + "img/The Global Elite.4ed12962.png";